module.exports = __webpack_public_path__ + "img/flow.b966be08.svg";